import React, {Component} from 'react';

import {HeadlineH1} from './text/Headlines';
import EntityTable from './table/EntityTable';
import windowTableConfig from './windowTableConfig';

export default class extends Component {
  _renderHeadline = () => {
    return <HeadlineH1>Sucheregebnis</HeadlineH1>;
  };
  _renderResult = ({searchWindows, loading}, user) => {
    if (loading) {
      return <div> loading</div>;
    }
    if (!searchWindows || searchWindows.length === 0) {
      return <div>keine Fenster für diesen Filter gefunden </div>;
    }
    return (
      <EntityTable
        tableConfig={windowTableConfig(user, window.innerHeight)}
        data={searchWindows}
        msg={'Noch keine Einträge erstellt'}
      />
    );
  };

  render() {
    const {searchWindowsQuery, user} = this.props;
    return (
      <div>
        {this._renderHeadline()}
        {this._renderResult(searchWindowsQuery, user)}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/WindowSearchResult.js